<div class="mt-5 title-container">
  <h1 class="col-7">Integración Blackboard</h1>
  <button
    class="boton-primario mt-2 btn-block btn-crear col-3"
    data-toggle="tooltip"
    data-placement="top"
    title="CREAR INTEGRACIÓN"
    alt="CREAR INTEGRACIÓN"
    (click)="crearIntegracion()"
  >
    CREAR INTEGRACIÓN
  </button>
</div>

<div class="form-container pl-4 pr-4 pb-5 pt-4">
  <div class="mb-4">
    <h6 class="mb-0">Búsqueda de integraciones realizadas:</h6>
  </div>
  <div class="row mt-4">
    <div class="col-2">
      <label class="label-form" for="instancia"
        >Instancia <span class="required"> (Obligatorio)</span></label
      >
      <select
        name="instancia"
        class="form-control select_criterios"
        id="instancia"
        [(ngModel)]="integracionForm.instanciaId"
        (ngModelChange)="getEscuelas()"
      >
        <option [value]="-1" default>Seleccionar</option>
        <option [value]="instancia.id" *ngFor="let instancia of instancias">
          {{ instancia.descripcion }}
        </option>
      </select>
    </div>
    <div class="col-3">
      <label class="label-form" for="escuela"
        >Escuela o programa <span class="required"> (Obligatorio)</span></label
      >
      <select
        name="escuela"
        class="form-control select_criterios"
        id="escuela"
        [(ngModel)]="integracionForm.escuelaId"
      >
        <option [value]="-1" selected hidden>Seleccionar</option>
        <option
          [value]="escuela.unidadAcademicaId"
          *ngFor="let escuela of escuelas"
        >
          {{ escuela.descripcion }}
        </option>
      </select>
    </div>
    <div class="col-3">
      <label class="label-form" for="asignatura">Sigla asignatura</label>
      <ng-select
        [notFoundText]="'No se encontraron resultados'"
        [loadingText]="'Buscando...'"
        placeholder="Ingresar sigla asignatura"
        [loading]="loadingSigla"
        [items]="filtroAsignaturas.listado"
        bindLabel="siglaIdSap"
        bindValue="idSeccion"
        [virtualScroll]="true"
        (scrollToEnd)="_integracionSharedService.endScrollSigla(this,searchValueSigla)"
        (change)="changeSiglaAsignatura($event)"
        (search)="onSearchSigla($event)"
        [(ngModel)]="filtroSigla"
        #selectSigla
      >
      </ng-select>
    </div>
    <div class="col-2">
      <label class="label-form" for="periodo">Periodo</label>
      <mat-form-field appearance="fill" class="form-field">
        <mat-select
          multiple
          class="select-multiple"
          placeholder="Seleccionar"
          #selectPeriodo
          [(ngModel)]="integracionForm.filtroPeriodos"
        >
          <mat-option
            *ngFor="let periodo of periodos"
            [value]="periodo.siglaPeriodo"
          >
            {{ periodo.siglaPeriodo }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-2 centrar_iconos_botones">
      <button
        class="boton-buscar"
        data-toggle="tooltip"
        data-placement="top"
        title="BUSCAR"
        alt="BUSCAR"
        (click)="busqueda()"
        [disabled]="
          integracionForm.instanciaId == -1 || integracionForm.escuelaId == -1
        "
      >
        <i class="bi bi-search"></i>
      </button>
      <button
        class="boton-secundario tamanio_iconos-boton"
        data-toggle="tooltip"
        data-placement="top"
        title="LIMPIAR"
        alt="LIMPIAR"
        (click)="limpiarFiltros()"
      >
        <i class="bi bi-x"></i>
      </button>
    </div>
  </div>
</div>
<div
  *ngIf="alertaExitosa.length != 0"
  class="alert alert-success tipografía_alertas mt-5 mb-4"
  role="alert"
>
  <i class="bi bi-check-circle-fill"></i>

  <div>
    <p class="titulo-alerta">{{ alertaExitosa[0] }}</p>
    <p class="cuerpo-alerta">
      {{ alertaExitosa[1] }} <br />
      {{ alertaExitosa[2] }}
    </p>
  </div>
  <button
    type="button"
    class="close tipografía_alertas mt-3"
    data-dismiss="alert"
    aria-label="Close"
    data-toggle="collapse"
    data-target="#collapseWidthExample"
    aria-expanded="true"
    aria-controls="collapseWidthExample"
  >
    <span aria-hidden="true" class="alert-success">&times;</span>
  </button>
</div>
<div
  *ngIf="alertaExitosaDeshabilitado.length != 0"
  class="alert alert-success tipografía_alertas mt-5 mb-4"
  role="alert"
>
  <i class="bi bi-check-circle-fill"></i>

    <p class="cuerpo-alerta">
      Ha deshabilitado la integración de la Asignatura <b>{{alertaExitosaDeshabilitado[0]}}</b> para el periodo <b>{{alertaExitosaDeshabilitado[1]}}</b><br>
      Esto no impacta las calificaciones que se han obtenido hasta la fecha. Si requiere una alineación para la misma sección de Portal de Calificaciones, debe crearla de nuevo.
    </p>
  <button
    type="button"
    class="close tipografía_alertas mt-3"
    data-dismiss="alert"
    aria-label="Close"
    data-toggle="collapse"
    data-target="#collapseWidthExample"
    aria-expanded="true"
    aria-controls="collapseWidthExample"
  >
    <span aria-hidden="true" class="alert-success alert-success-deshabilitar">&times;</span>
  </button>
</div>
<div
  *ngIf="alertaError.length != 0"
  class="alert alert-danger tipografía_alertas mt-5 mb-4"
  role="alert"
>
  <i class="bi bi-x-circle-fill"></i>

  <p class="titulo-alerta-error">{{ alertaError }}</p>
  <button
    type="button"
    class="close tipografía_alertas"
    data-dismiss="alert"
    aria-label="Close"
    data-toggle="collapse"
    data-target="#collapseWidthExample"
    aria-expanded="true"
    aria-controls="collapseWidthExample"
  >
    <span aria-hidden="true" class="alert-danger">&times;</span>
  </button>
</div>
<!-- Tabla -->
<div style="margin-top: 40px">
  <table
    *ngIf="!renderTableIntegraciones"
    [dtOptions]="dtOptions"
    datatable
    class="row-border hover table-striped display nowrap"
    aria-describedby="tabla ponderacion masiva"
  >
    <thead class="header_tabla">
      <tr>
        <th>Instancia</th>
        <th>Escuela o programa</th>
        <th>Sigla asignatura</th>
        <th>Nombre asignatura</th>
        <th>Estado integración BB</th>
        <th>Periodo</th>
        <th>Fecha creación</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style="width: 100%">Procesando...</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
  <table
    id="tabla-ponderacion"
    *ngIf="renderTableIntegraciones"
    [dtOptions]="dtOptions"
    datatable
    class="row-border hover table-striped display nowrap"
    aria-describedby="tabla ponderacion masiva"
  >
    <thead class="header_tabla">
      <tr>
        <th>Instancia</th>
        <th>Escuela o programa</th>
        <th>Sigla asignatura</th>
        <th>Nombre asignatura</th>
        <th>Estado integración BB</th>
        <th>Periodo</th>
        <th>Fecha creación</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let integracion of listaIntegraciones; index as indexReemplazo"
      >
        <td class="py-0">
          <p
            class="celda"
            data-toggle="tooltip"
            data-placement="top"
            [title]="integracion.descInstancia"
          >
            {{ integracion.descInstancia }}
          </p>
        </td>
        <td class="py-0">
          <p
            class="celda"
            data-toggle="tooltip"
            data-placement="top"
            [title]="integracion.nombrePrograma"
          >
            {{ integracion.nombrePrograma }}
          </p>
        </td>
        <td class="py-0">
          <p
            class="celda"
            data-toggle="tooltip"
            data-placement="top"
            [title]="integracion.siglaAsignatura"
          >
            {{ integracion.siglaAsignatura }}
          </p>
        </td>
        <td class="py-0">
          <p
            class="celda"
            data-toggle="tooltip"
            data-placement="top"
            [title]="integracion.nombreAsignatura"
          >
            {{ integracion.nombreAsignatura }}
          </p>
        </td>
        <td class="py-0">
          <p class="celda celda-vigencia">
            <span
              class="badge badge-pill vigente d-flex justify-content-center py-2"
              *ngIf="integracion.estadoIntegracion"
              >Vigente</span
            >
            <span
              class="badge badge-pill deshabilitado d-flex justify-content-center py-2"
              *ngIf="!integracion.estadoIntegracion"
              >Deshabilitado</span
            >
          </p>
        </td>
        <td class="py-0">
          <p
            class="celda"
            data-toggle="tooltip"
            data-placement="top"
            [title]="integracion.siglaPeriodo"
          >
            {{ integracion.siglaPeriodo }}
          </p>
        </td>
        <td class="py-0">
          <p class="celda">{{ integracion.fechaCreacion }}</p>
        </td>
        <td class="d-flex justify-content-center py-0">
          <div id="popover-container" class="cstm-popover-container">
            <button class="btn" (click)="togglePopover(indexReemplazo)">
              <i class="bi bi-three-dots-vertical boton-accion"></i>
            </button>
            <div
              [id]="'cstm-popover-' + indexReemplazo"
              class="cstm-popover arrow_box"
              [ngClass]="{
                'cstm-popover-showing':
                  indexReemplazo === indexAccionSeleccionado,
                ' d-none': indexReemplazo !== indexAccionSeleccionado
              }"
            >
              <ul class="list-group">
                <ul>
                  <li
                    class="list-group-item border-0 py-1 popover-item-disabled"
                    *ngIf="!integracion.estadoIntegracion"
                    title="Deshabilitar"
                    disabled
                  >
                    <div class="row align-items-center">
                      <div class="col-2 text-center p-0">
                        <i class="bi bi-trash boton-accion_popover px-3"></i>
                      </div>
                      <div class="col-10 p-0 text-left">
                        <p class="mb-0 pl-4">Deshabilitar</p>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item border-0 py-1"
                    (click)="deshabilitarIntegracion()"
                    (keydown)="deshabilitarIntegracion()"
                    *ngIf="integracion.estadoIntegracion"
                    title="Deshabilitar"
                    disabled
                  >
                    <div class="row align-items-center">
                      <div class="col-2 text-center p-0">
                        <i class="bi bi-trash boton-accion_popover px-3"></i>
                      </div>
                      <div class="col-10 p-0 text-left">
                        <p class="mb-0 pl-4">Deshabilitar</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </ul>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<!-- MODAL ELIMINAR -->
<button
  id="modal-deshabilitar"
  class="btn d-none"
  data-toggle="modal"
  data-target="#deshabilitar"
>
  CERRAR Deshabilitar Integración
</button>
<div
  class="modal fade"
  id="deshabilitar"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          title="CERRAR"
          alt="CERRAR"
        >
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row align-items-center my-3 mx-4 text-container">
            <p class="mb-0 text-confirmar">
              ¿Está seguro que desea deshabilitar esta integración?<br /><span>
                Esta acción es permanente
              </span>
            </p>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="my-4">
          <button
            class="boton-secundario ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="NO, MANTENER"
            alt="NO, MANTENER"
            data-dismiss="modal"
            id="btn-modal-salir-dismiss"
          >
            NO, MANTENER
          </button>
          <button
            class="boton_principal_modal ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="SI, DESHABILITAR"
            alt="SI, DESHABILITAR"
            data-dismiss="modal"
            (click)="deleteIntegracion()"
          >
            SI, DESHABILITAR
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL ELIMINAR -->
